import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import classNames from 'classnames';

import { Row } from 'components/Layout';
import Image from 'components/Image';

import { forwardIcon, forwardIcon_over, infoIcon, infoIcon_over } from 'img/icons'
import styles from './serviceSelection.module.scss'


let LinkButton = ({ url, src, hover, tip }) => {
    let btn = <Image className={styles.serviceButton} src={src} hover={hover} />

    return <div data-tip={tip} >{
        url.startsWith("http") ? (
            <a href={url} rel="noopener noreferrer" target="_blank">{btn}</a>
        ) : (
            <Link to={url}>{btn}</Link>
        )
    }</div>
}

let ServiceItem2Btn = ({ item }) =>
    <Link to={item.url}
        className={classNames(styles.col, styles.serviceItem)}
        onClick={e => item.disabled ? e.preventDefault() : {}}
        disabled={item.disabled}
    >
        <img alt={item.name} src={item.icon} />
        <label>{item.name}</label>
        <Row>
            {item.guideTopic && <LinkButton
                url={`/guide/${item.guideTopic}`}
                src={infoIcon}
                hover={infoIcon_over}
                tip='Info sul servizio'
            />}
            {item.url && !item.disabled && <LinkButton
                url={item.url}
                src={forwardIcon}
                hover={forwardIcon_over}
                tip='Vai al servizio'
            />}
            <ReactTooltip effect='solid' />
        </Row>
    </Link>

let ServiceItem = ({ item, isHover, setIsHover, goBack }) => {
    let content = <>
        <img alt={item.name} src={isHover === item.name ? item.iconHover : item.icon} />
        <label>{item.name}</label>
    </>
    let action = (item.action === 'goBack') ? goBack : undefined

    return <>
        {
            item.url ? (
                item.url.startsWith("http") ? (
                    <a href={item.url} rel="noopener noreferrer" target="_blank"
                        className={classNames(styles.col, styles.serviceItem, styles.serviceItemBtn)}
                        onClick={(e) => item.disabled ? e.preventDefault() : {}}
                        onMouseOver={() => item.disabled ? null : setIsHover(item.name)}
                        onMouseOut={() => item.disabled ? null : setIsHover(null)}
                        disabled={item.disabled}
                    >{content}</a>
                ) : (
                    <Link to={item.url}
                        className={classNames(styles.col, styles.serviceItem, styles.serviceItemBtn)}
                        onClick={(e) => item.disabled ? e.preventDefault() : {}}
                        onMouseOver={() => item.disabled ? null : setIsHover(item.name)}
                        onMouseOut={() => item.disabled ? null : setIsHover(null)}
                        disabled={item.disabled}
                    >{content}</Link>
                )
            ) : (
                <div
                    className={classNames(styles.col, styles.serviceItem, styles.serviceItemBtn)}
                    onClick={(e) => item.disabled ? e.preventDefault() : action()}
                    onMouseOver={() => item.disabled ? null : setIsHover(item.name)}
                    onMouseOut={() => item.disabled ? null : setIsHover(null)}
                    disabled={item.disabled}
                >{content}</div>
            )
        }
    </>
}

const ServiceSelectionPage = ({ menu }) => {
    const [isHover, setIsHover] = useState(null)
    let navigate = useNavigate();

    return <Row>{
        menu.map(item => (item.url && item.guideTopic) ? (
            <ServiceItem2Btn key={item.name} item={item} />
        ) : (
            <ServiceItem key={item.name}
                item={item}
                isHover={isHover}
                setIsHover={setIsHover}
                goBack={() => navigate(-1)}
            />
        ))
    }</Row>
}

export default ServiceSelectionPage